import { createSlice  } from '@reduxjs/toolkit'

const initialState = {
    finalPayList: {
      requesting: false,
      items: [],
      pagination: {
		  current_page: 1,
		  per_page: 10,
		  total: 0,
	  },
      error: null,
      success: false,
      filters: {},
    },
    finalPayDetails: {
      requesting: false,
      error: null,
      success: false,
      data: null
    },
  };

export const finalPaySlice = createSlice({
  name: 'finalPay',
  initialState,
  reducers: {
    getFinalPayList: (state, action) => {
        state.finalPayList.requesting = true;
        state.finalPayList.error = null;
        state.finalPayList.items = [];
        state.finalPayList.success = false;
        state.finalPayList.filters = action.payload;
    },
    getFinalPayListSuccess: (state, action) => {
		const { data, current_page, per_page, total} = action.payload;
        state.finalPayList.requesting = false;        
        state.finalPayList.items = data;
        state.finalPayList.success = true; 
        state.finalPayList.pagination.current_page = current_page;
        state.finalPayList.pagination.per_page = per_page;
        state.finalPayList.pagination.total = total;
    },
    getFinalPayListFail: (state, action) => {        
        state.finalPayList.requesting = false;
        state.finalPayList.error = action.payload;
    },
    getFinalPayDetails: (state) => {
        state.finalPayDetails.requesting = true;
        state.finalPayDetails.error = null;
        state.finalPayDetails.data = null;
        state.finalPayDetails.success = false; 
    },
    getFinalPayDetailsSuccess: (state, action) => {
        state.finalPayDetails.requesting = false;
        state.finalPayDetails.data = action.payload;
        state.finalPayDetails.success = true; 
    },
    getFinalPayDetailsFail: (state, action) => {        
        state.finalPayDetails.requesting = false;
        state.finalPayDetails.error = action.payload;
    },
    doFinalPayCreate: (state) => {
        state.finalPayDetails.requesting = true;
        state.finalPayDetails.error = null;
        state.finalPayDetails.data = null;
        state.finalPayDetails.success = false; 
    },
    doFinalPayUpdate: (state) => {
        state.finalPayDetails.requesting = true;
        state.finalPayDetails.error = null;
        state.finalPayDetails.data = null;
        state.finalPayDetails.success = false; 
    },
    doFinalPayDelete: (state) => {
        state.finalPayDetails.requesting = true;
        state.finalPayDetails.error = null;
        state.finalPayDetails.data = null;
        state.finalPayDetails.success = false; 
    },
  },
})

export const { 
    getFinalPayList, getFinalPayListSuccess, getFinalPayListFail,
    getFinalPayDetails, getFinalPayDetailsSuccess, getFinalPayDetailsFail,
    doFinalPayCreate, doFinalPayUpdate, doFinalPayDelete
} = finalPaySlice.actions

export default finalPaySlice.reducer